var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailIconLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1357 12.0955C15.3385 12.2841 15.605 12.3888 15.8819 12.3888C16.1587 12.3888 16.4253 12.2841 16.628 12.0955L29.2875 0.343181C28.8627 0.148026 28.401 0.0460474 27.9334 0.0440941H3.83018C3.36258 0.0460505 2.90085 0.148032 2.47607 0.343181L15.1357 12.0955Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1189 13.7051C17.5092 14.2669 16.7107 14.5784 15.8817 14.5784C15.0527 14.5784 14.2542 14.2668 13.6445 13.7051L0.900504 1.87137C0.668913 2.32306 0.546637 2.82292 0.543457 3.33065V18.6691C0.543457 19.5409 0.889742 20.3768 1.50602 20.9933C2.12254 21.6096 2.95841 21.9559 3.83026 21.9559H27.9335C28.8053 21.9559 29.6412 21.6096 30.2577 20.9933C30.874 20.3768 31.2203 19.5409 31.2203 18.6691V3.33065C31.2171 2.82296 31.0948 2.32308 30.8633 1.87137L18.1189 13.7051Z",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIconLogin);
export default __webpack_public_path__ + "static/media/mail-icon-login.890ae84422ff47c71ce6a28b13b9615e.svg";
export { ForwardRef as ReactComponent };